/*
 * @Author: liuc
 * @Date: 2020-04-08 13:43:52
 * @Description:
 */
/**
 * @Author: liuchang
 * @Date: 2019-08-14 20:27:01
 * @Description: vuex
 */
import Vue from 'vue';
import Vuex from 'vuex';
import Common from '../services/Common';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userPicture: '', // 用户头像
        defaultAvatar: require('@/assets/images/default_avatar_light.png'),
        devcorpVersion: 'v3.2.0.159', // 当前版本号
        userInfo: {}, // 当前登录人信息
        tenantList: [] // 团队信息
    },
    getters: {
    },
    mutations: {
        setUserInfo (state, data) {
            state.userInfo = data;
            state.userInfo.frontTenantId = data.frontTenantId ? data.frontTenantId : '';
        },
        setTenantList (state, data) {
            state.tenantList = data;
        },
        setUserPicture (state, data) {
            state.userPicture = data;
        }
    },
    actions: {
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
});



// WEBPACK FOOTER //
// ./src/store/index.js